import { useNavigate } from 'react-router-dom';

function OtherWork() {
  const navigate = useNavigate();
  return (
    <div className="other-work-box">
      <h1 className="offer-title">
        EL OBJETIVO: JUGAR AL GOLF. EL PREMIO: LO QUE OCURRE MIENTRAS TANTO.
      </h1>
      <div
        className="section-login-img-v3"
        style={{
          backgroundImage: `url("images/BRK_GOLF_VERANO_4473.webp")`,
          backgroundSize: 'cover',
          backgroundPosition: ' 13% center',
          width: '100%',
          minHeight: '600px',
        }}
      ></div>
      <h1 className="offer-unlock-more">CUSTOM DESIGN</h1>
      <div className="custom-design-description-wrapper">
        <p>
          Whether you need team apparel, a custom collection, or your own-label
          line, we’re here to bring your vision to life. Our design team helps
          you create garments that reflect your brand’s identity. Let’s build
          something exceptional together.
        </p>
      </div>
      <btn
        className="btn-read-more-custom-design"
        onClick={() => navigate('/custom-design')}
      >
        Read more
      </btn>
      {/* <div className="grid-container-other-work">
        <div className="flex-container-work">
          <img src="/images/design.svg" alt="img" className="img-work" />
          <h2>Custom-made</h2>
          <p>
            We offer personalized collections. Let our design team help you.
          </p>
        </div>
        <div className="flex-container-work">
          <img src="/images/custome.svg" alt="img" className="img-work" />
          <h2>Staff</h2>
          <p>
            Elevate your team's attire and enjoy significant discounts on our
            garments.
          </p>
        </div>
        <div className="flex-container-work">
          <img
            src="/images/label-collection.svg"
            alt="img"
            className="img-work"
          />
          <h2>Own-label-collection</h2>
          <p>
            Choose own-label-collections for your products and give your
            customers a new experience.
          </p>
        </div>
      </div> */}
    </div>
  );
}

export default OtherWork;
